module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst dataJSON = model.dataJSON || {}\nconst fieldConfig = model.config || {}\nconst additionalClasses = [];\nif(model.disabled) additionalClasses.push('disabled');\nconst fieldConfigs = {\nprice: utils.simpleMerge({\nformat: {\nsuffix: ' €/h',\ndecimals: 2,\n},\nformatData: {\ndecimals: 10,\n},\n}, (fieldConfig.fields || {}).price),\npriceCommission: utils.simpleMerge({\nformat: {\nsuffix: ' €/h',\ndecimals: 2,\n},\n// formatData: {\n//     decimals: 2,\n// },\n}, (fieldConfig.fields || {}).priceCommission),\nnrOfHoursUntilOvertimeStart: utils.simpleMerge({\nformat: {\nsuffix: ' h',\ndecimals: 0,\n},\n}, (fieldConfig.fields || {}).nrOfHoursUntilOvertimeStart),\novertimePremiumPercentage: utils.simpleMerge({\nformat: {\nsuffix: ' %',\ndecimals: 0,\n},\n}, (fieldConfig.fields || {}).overtimePremiumPercentage),\n}\n%><div class=\"<%- additionalClasses.join(' ') %>\" data-field-code=\"<%- model.fieldCode %>\"><%\n%><%- include('../../../../base/form/fields/text', { model: { atom: { dataType: 'float' }, dataFLOAT: dataJSON.price, fieldCode: 'price', additionalCSSClass: 'fieldOf_price', placeholder: storage.__('form.fields.hourlyRate.price.placeholder'), innerTitle: storage.__('form.fields.hourlyRate.price.innerTitle'), config: fieldConfigs.price }}) %><%\nif(config.showCommission){\n%><%- include('../../../../base/form/fields/text', { model: { atom: { dataType: 'float' }, dataFLOAT: dataJSON.priceCommission, fieldCode: 'priceCommission', additionalCSSClass: 'fieldOf_priceCommission', placeholder: storage.__('form.fields.hourlyRate.price.placeholder'), innerTitle: storage.__('form.fields.hourlyRate.priceCommission.innerTitle'), config: fieldConfigs.priceCommission }}) %><%\n}\n%><%- include('../../../../base/form/fields/text', { model: { atom: { dataType: 'float' }, dataFLOAT: dataJSON.nrOfHoursUntilOvertimeStart, fieldCode: 'nrOfHoursUntilOvertimeStart', additionalCSSClass: 'fieldOf_nrOfHoursUntilOvertimeStart', placeholder: storage.__('form.fields.hourlyRate.nrOfHoursUntilOvertimeStart.placeholder'), innerTitle: storage.__('form.fields.hourlyRate.nrOfHoursUntilOvertimeStart.innerTitle'), config: fieldConfigs.nrOfHoursUntilOvertimeStart } }) %><%\n%><%- include('../../../../base/form/fields/text', { model: { atom: { dataType: 'float' }, dataFLOAT: dataJSON.overtimePremiumPercentage, fieldCode: 'overtimePremiumPercentage', additionalCSSClass: 'fieldOf_overtimePremiumPercentage', placeholder: storage.__('form.fields.hourlyRate.overtimePremiumPercentage.placeholder'), innerTitle: storage.__('form.fields.hourlyRate.overtimePremiumPercentage.innerTitle'), config: fieldConfigs.overtimePremiumPercentage } }) %><%\n%></div>"
  , __filename = "components/templates/core/form/fields/hourlyRate.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const dataJSON = model.dataJSON || {}
const fieldConfig = model.config || {}
const additionalClasses = [];
if(model.disabled) additionalClasses.push('disabled');
const fieldConfigs = {
price: utils.simpleMerge({
format: {
suffix: ' €/h',
decimals: 2,
},
formatData: {
decimals: 10,
},
}, (fieldConfig.fields || {}).price),
priceCommission: utils.simpleMerge({
format: {
suffix: ' €/h',
decimals: 2,
},
// formatData: {
//     decimals: 2,
// },
}, (fieldConfig.fields || {}).priceCommission),
nrOfHoursUntilOvertimeStart: utils.simpleMerge({
format: {
suffix: ' h',
decimals: 0,
},
}, (fieldConfig.fields || {}).nrOfHoursUntilOvertimeStart),
overtimePremiumPercentage: utils.simpleMerge({
format: {
suffix: ' %',
decimals: 0,
},
}, (fieldConfig.fields || {}).overtimePremiumPercentage),
}

    ; __line = 38
    ; __append("<div class=\"")
    ; __append( additionalClasses.join(' ') )
    ; __append("\" data-field-code=\"")
    ; __append( model.fieldCode )
    ; __append("\">")
    ; 

    ; __line = 39
    ; __append( include('../../../../base/form/fields/text', { model: { atom: { dataType: 'float' }, dataFLOAT: dataJSON.price, fieldCode: 'price', additionalCSSClass: 'fieldOf_price', placeholder: storage.__('form.fields.hourlyRate.price.placeholder'), innerTitle: storage.__('form.fields.hourlyRate.price.innerTitle'), config: fieldConfigs.price }}) )
    ; 
if(config.showCommission){

    ; __line = 41
    ; __append( include('../../../../base/form/fields/text', { model: { atom: { dataType: 'float' }, dataFLOAT: dataJSON.priceCommission, fieldCode: 'priceCommission', additionalCSSClass: 'fieldOf_priceCommission', placeholder: storage.__('form.fields.hourlyRate.price.placeholder'), innerTitle: storage.__('form.fields.hourlyRate.priceCommission.innerTitle'), config: fieldConfigs.priceCommission }}) )
    ; 
}

    ; __line = 43
    ; __append( include('../../../../base/form/fields/text', { model: { atom: { dataType: 'float' }, dataFLOAT: dataJSON.nrOfHoursUntilOvertimeStart, fieldCode: 'nrOfHoursUntilOvertimeStart', additionalCSSClass: 'fieldOf_nrOfHoursUntilOvertimeStart', placeholder: storage.__('form.fields.hourlyRate.nrOfHoursUntilOvertimeStart.placeholder'), innerTitle: storage.__('form.fields.hourlyRate.nrOfHoursUntilOvertimeStart.innerTitle'), config: fieldConfigs.nrOfHoursUntilOvertimeStart } }) )
    ; 

    ; __line = 44
    ; __append( include('../../../../base/form/fields/text', { model: { atom: { dataType: 'float' }, dataFLOAT: dataJSON.overtimePremiumPercentage, fieldCode: 'overtimePremiumPercentage', additionalCSSClass: 'fieldOf_overtimePremiumPercentage', placeholder: storage.__('form.fields.hourlyRate.overtimePremiumPercentage.placeholder'), innerTitle: storage.__('form.fields.hourlyRate.overtimePremiumPercentage.innerTitle'), config: fieldConfigs.overtimePremiumPercentage } }) )
    ; 

    ; __line = 45
    ; __append("</div>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/core/form/fields/hourlyRate.ejs

}